import React, { useContext } from 'react';
import { useRouter } from 'next/router';
import { ModalContext, IModalContext } from 'contexts/modal';
import Link from 'components/link';
import styles from './style.module.scss';
import { buildClassName } from 'utils/build-class-name';
import { listingPageModalIds } from 'constants/test-constants';
import generateFullAddress from 'utils/get-full-address';

import type Listing from 'data/listing';

interface Props {
  listing: Listing;
  itemProp?: string;
  isVisible: boolean;
  shouldScramble: boolean;
  isFromPriceHistory?: boolean;
}

export default function AddressHeading({ listing, itemProp, isVisible, shouldScramble, isFromPriceHistory = false }: Props) {
  const { addressPathWithFallback, getStreet, seoType, city, province } = listing;
  const { closeAllModals } = useContext(ModalContext) as IModalContext;
  // Return the full SEO street address for the heading regardless if the user is authenticated or not for SEO purposes
  const street = getStreet(true);
  const router = useRouter();
  const onAddressPath = addressPathWithFallback === router.asPath.replace(/^\/+/g, '');
  const addressText = generateFullAddress(street, city, province, shouldScramble);

  const address = <div className={buildClassName((!isVisible) && 'blur', styles.street)}>
    <h1 itemProp={itemProp} data-testid={listingPageModalIds.listingAddress}>{addressText}</h1>
    <h2 className={!isVisible ? 'blur' : ''}>{seoType ? seoType : 'Real Estate'}</h2>
  </div>;

  if (isFromPriceHistory || onAddressPath || !addressPathWithFallback) {
    return address;
  } else {
    return <Link href={addressPathWithFallback} onClick={closeAllModals}>{address}</Link>;
  }
}
